import PropTypes from "prop-types";
import styles from "./tableOfContent.module.scss";

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      articleTitle: PropTypes.string,
      sections: PropTypes.array,
    }),
  ).isRequired,
};

// add smooth scroll
// const linkScrollProps = {
//   style: { cursor: "pointer" },
//   smooth: true,
//   offset: -70,
//   duration: 500,
// };
function TableOfContent(props: any) {
  const { items, anchorLinkClassNames } = props;

  let articleIndex = 0;
  const alphabet = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  return (
    <div className={styles.table_of_content_block}>
      {items.map((article: any) => {
        let sectionIndex = 0;
        if (!article.articleTitle) { return null; }
        articleIndex += 1;
        return (
          <div key={articleIndex} className={styles.article_block}>
            <>
              <span>{`${articleIndex}. `}</span>
              <a
                className={`${styles.article_title} ${anchorLinkClassNames}`}
                href={`#${article.articleTitle}`}
              >
                {article.articleTitle}
              </a>
            </>

            {article.sections.map((section: any) => {
              if (!section.title) { return null; }
              sectionIndex += 1;
              return (
                <div className={styles.section_block} key={sectionIndex}>
                  <span>{`${alphabet[sectionIndex].toLowerCase()}. `}</span>
                  <a href={`#${section.title}`} className={styles.section_title}>
                    {section.title}
                  </a>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

TableOfContent.propTypes = propTypes;

export default TableOfContent;
